<template>
  <div class="pages">
    <div class="flex">
      <div style="width:320px;padding:0 20px;">
        <div class="left">
          <!-- <div class="text-center ">
            <div class="block change" style="padding: 30px 0;border-radius: 10px;">
              <img style="width: 140px; height: 60px" :src="carClassify.src" />
              <div style="font-size: 30px;font-weight: 600;color: #fff;margin-top: 10px;">{{carClassify.name}}</div>
            </div>
          </div> -->
          <div class="text-center" style="border-radius: 10px;">
            <div @click="selectCar(index)" v-for="(item,index) in carClassify1" :key="index" class="block"
              style="padding: 30px 10px;border-radius: 30px;margin-bottom: 20px;"
              :style="{background: car_type1==index?'#3CB3FE':'#EBF1FF'}">
              <img style="width: 145px; height: 60px" :src="item.src" />
              <div style="margin-top: 5px;font-size: 30px;" :style="{color: car_type1==index?'#fff':'#000'}">
                {{item.name}}
              </div>
            </div>
          </div>
        </div>
        <!-- <div class=" " style="color: #fff;">
          <div @click="$router.push('/recode?status=1')" style="margin-top: 40px; padding: 20px; text-align: center; background: linear-gradient(180deg, #FF7181 0%, #FF97A1 100%);border-radius: 10px 10px 10px 10px;">
            <img src="../../assets/images/mis.png" style="width: 78px;height:78px;" />
            <div style="font-size: 20px;">成绩与错题</div>
          </div>
          <div @click="dialogVisible=true" style="margin-top: 40px; padding: 20px ;text-align: center;background: linear-gradient(180deg, #648FFF 0%, #96B3FC 100%);border-radius: 10px 10px 10px 10px;">
            <img src="../../assets/images/misicon1.png" style="width: 78px;height:78px;" />
            <div style="font-size: 20px;">模拟考试</div>
          </div> -->
        <!-- <div @click="$router.push('/recode')" style="margin-top: 40px; padding: 30px ;text-align: center;background: linear-gradient(180deg, #FFA067 0%, #FF7254 100%);border-radius: 10px 10px 10px 10px;">
            <img src="../../assets/images/recordIcon.png" style="width: 30px;height: 30px;" />
            <div>成绩记录</div>
          </div> -->
        <!-- <div @click="goCollect" style="margin-top: 40px; padding: 20px ;text-align: center;background: linear-gradient(180deg, #fcae5f 0%, #fdc27e 100%);border-radius: 10px 10px 10px 10px;">
            <img src="../../assets/images/misi.png" style="width: 78px;height:78px;" />
            <div style="font-size: 20px;">收藏</div>
          </div>
        </div> -->
      </div>

      <div class=" carType">

        <div class=" " style="color: #fff;display: flex;">
          <!-- @click="dialogVisible=true" 原来点击弹窗方式 -->
          <div @click="showModal=true"
            style="padding: 20px ;text-align: center;background: linear-gradient(180deg, #648FFF 0%, #96B3FC 100%);border-radius: 30px;flex: 1;margin: 0 80px 20px 0;">
            <img src="../../assets/images/misicon1.png" style="width: 78px;height:78px;" />
            <div style="font-size: 20px;">模拟考试</div>
          </div>
          <div @click="$router.push('/recode?status=1')"
            style="padding: 20px; text-align: center; background: linear-gradient(180deg, #FF7181 0%, #FF97A1 100%);border-radius: 30px;flex: 1;margin: 0 80px 20px 0;">
            <img src="../../assets/images/mis.png" style="width: 78px;height:78px;" />
            <div style="font-size: 20px;">成绩与错题</div>
          </div>
          <div @click="goCollect"
            style="padding: 20px ;text-align: center;background: linear-gradient(180deg, #fcae5f 0%, #fdc27e 100%);border-radius: 30px;flex: 1;margin: 0 80px 20px 0;">
            <img src="../../assets/images/misi.png" style="width: 78px;height:78px;" />
            <div style="font-size: 20px;">收藏</div>
          </div>
          <div @click="threeTest"
            style="padding: 20px ;text-align: center;background: linear-gradient(180deg, #9F8AFC 0%, #AF93F4 100%);border-radius: 30px;flex: 1;margin: 0 0 20px 0;">
            <img src="../../assets/images/subtract.png" style="width: 78px;height:78px;" />
            <div style="font-size: 20px;">三力测试</div>
          </div>
        </div>

        <div class="navClassify">
          <div style="height: 88px;line-height: 88px;color: #fff;font-weight: 600;">
            <ul class="flex flex-row-between">
              <li @click="selectSubject(index)" :class="subject==index?'change':''" v-for="(item,index) in navClassify"
                :key="index" class="navClassifyBlock">
                {{item.name}}
              </li>
            </ul>
          </div>
        </div>
        <div class="" style="padding: 20px;width:1440px">
          <!-- <div style="display: flex;background: #D9EAFF;height: 80px;border-radius: 20px 20px 0 0;width: 1395px;">
            <div class="arrList" style="border-right: 3px solid #375ee7;">考题</div>
            <div class="arrList" style="border-right: 3px solid #375ee7;">加强</div>
            <div class="arrList">加练</div>
          </div> -->
          <div class="flex  " style="overflow:auto;height:700px;overflow-y:scroll;overflow-x: hidden;margin-top: 20px;">
            <div v-for="(item,index) in list" :key="index" class="">
              <!-- <div style="margin: 20px 0;font-weight: bold;font-size: 26px;">
								{{item.name}}
							</div> -->
              <div @click="go(item1,'精选题库')"
                style="width: 350px; padding: 5px 10px ;border-radius: 10px;margin-bottom: 20px;margin-right: 140px;"
                v-for="(item1,index1) in item.paper" :key="index1" class="flex"
                :style="{background: item1.color ? item1.color : '#EBF1FF'}">
                <div style="margin: auto;" class="flex flex-col-center">
                  <img src="../../assets/images/cateIcon.png" style="width: 47px;height:47px;" />
                  <span style="color: #333333;font-size: 24px;">{{item1.name}}</span>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <el-dialog :visible.sync="dialogVisible" :show-close="false" class="headerlog">
        <div slot='title'
          style="font-weight: bold;font-size: 25px; background: #5966C6;padding: 20px;text-align: center;color: #fff;">
          奇顺-考试系统
        </div>

        <div style="margin-top: 20px;">
          <el-row type="flex">
            <el-col :span="10"
              style="text-indent: 20px; line-height: 35px; font-weight: bold;font-size:22px; border: 1px solid #333;padding: 20px;color: #375EE7;">
              <div style="">1.遵守考场纪律，服从监考人员指挥。</div>
              <div>2.进入考场，手机，拷机关机。禁止抽烟，禁止吃零食</div>
              <div>3.未经工作人员允许.考生禁止随意出入考场</div>
              <div>4.考场内禁止大声喧哗，禁止随意走动。</div>
              <div>5.考试中认真答题，不准交投接耳。</div>
              <div>6.考试不准冒名顶替，不准弄虚作假。</div>
              <div>7.注意考场卫生，禁止随意吐痰，禁止乱扔纸屑。</div>
            </el-col>
            <el-col :span="14 " style="background: linear-gradient(to bottom,#7A9ABB,#9DADB2);padding: 40px;">
              <div>
                <div style="text-align: center;font-weight: bold;font-size: 25px;color: #333;">
                  奇顺无纸化考场【01】号考台</div>

                <div style="color: red;font-weight: bold;font-size: 20px;margin: 40px 0;line-height: 50px;">
                  <div>身份证号：0123456</div>
                  <div>考生姓名：奇顺</div>
                  <div>点击[确认]按钮开始考试！</div>
                </div>

                <div style="display: flex;justify-content: flex-end;">
                  <el-button plain type="info" @click="goExam('模拟考试')">确定</el-button>
                </div>

              </div>
            </el-col>
          </el-row>
        </div>
        <!-- <div class="text-center">
					<div class="u-font-20 u-font-weight ">
						模拟考试不能修改答案，每做一题，系统 </br>自动计算错误题数，及格标准为90分
					</div>

					<div class="u-font-18  " style="color: #008EFF;margin-top: 40px;">
						点击确定开始考试
					</div>
				</div> -->
        <!-- <span slot="footer" class="dialog-footer">
					<el-button @click="dialogVisible=false">返回</el-button>
					<el-button type="primary" @click="goExam('模拟考试')">确定</el-button>
				</span> -->
      </el-dialog>

    </div>

    <transition name="fade">
      <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
        <div class="modal-content">
          <img :src="navClassify[subject].id==1?'/static/img/subject1.png':'/static/img/subject4.png'" style="width: 100%;position: relative;">
          <div @click="closeModal"
            style="width: 50px;height: 50px;z-index: 9999;position: absolute;top: 80px;left: 65px">
          </div>
          <div style="display: flex;width: 100%;border: 1px solid #d1d1d1;height: 100%;">
            <div style="background-color: #f0f0f0;width: 100%;display: flex;font-size: 24px;">
              <div style="flex: 1;border: 1px solid #999;">
                <div style="padding: 100px 0 0 40px;">
                  <div class="rule-item">考试须知</div>
                  <div class="rule-item">1. 遵守考场纪律，服从监考人员指挥。</div>
                  <div class="rule-item">2. 进入考场、手机关机。禁止抽烟，禁止吃零食。</div>
                  <div class="rule-item">3. 未经工作人员允许，考生禁止随意出入考场。</div>
                  <div class="rule-item">4. 考场内禁止大声喧哗，禁止随意走动。</div>
                  <div class="rule-item">5. 考试中认真答题，不准交头接耳。</div>
                  <div class="rule-item">6. 考试中不准冒名顶替，不准弄虚作假。</div>
                  <div class="rule-item">7. 注意考场卫生，禁止随地吐痰，禁止乱扔纸屑。</div>
                  <div class="rule-item">8. 爱护公物及考试设备。</div>
                </div>
              </div>
              <div style="flex: 1;border: 1px solid #999;border-left: none;">
                <div style="padding: 100px 0 0 40px;">
                  <div>理论考试01号考台</div>
                  <div style="margin-top: 20px;color: red;">身份证号: 012345678901234567</div>
                  <div style="color: red;">考生姓名: 奇顺交规</div>
                  <div style="text-align: center;">
                    <button
                      style="width: 140px;height: 50px;background-color: white;border: 1px solid #ccc;font-size: 16px;line-height: 50px;font-weight: 500;margin: 20px 0;"
                      @click="goExam('模拟考试')">确认</button>
                  </div>
                  <div class="tip-text">点击“确认”按钮开始考试！</div>
                  <div class="operation-tip">操作提示: 每题考试答案确定后，点击【下一题】，电脑立即判定所选答案，如选择错误，系统将提示正确答案，提示后不允许修改答案。
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>

  </div>
</template>

<script>
  import {
    mapState,
    mapMutations
  } from 'vuex'

  export default {
    data() {
      return {
        car_type1: 0,
        carClassify1: [{
            name: '小车',
            src: require('@/assets/images/cart1.png'),
            srcs: require('@/assets/images/cart1.png')
          },
          {
            name: '货车',
            src: require('@/assets/images/cart2.png'),
            srcs: require('@/assets/images/cart2.png')
          },
          {
            name: '客车',
            src: require('@/assets/images/cart3.png'),
            srcs: require('@/assets/images/cart3.png')
          },
          {
            name: '摩托车',
            src: require('@/assets/images/cart4.png'),
            srcs: require('@/assets/images/cart4.png')
          },
          {
            name: '三力测试',
            src: require('@/assets/images/cart7.png'),
            srcs: require('@/assets/images/cart7.png')
          }
        ],
        dialogVisible: false,
        navClassify: [{
            name: '科目一',
            id: 1
          },
          {
            name: '科目四',
            id: 4
          },
          {
            name: '注销恢复',
            id: 6
          },
          {
            name: '满分学习',
            id: 5
          },
          // {
          //   name: '三力测试',
          //   id: 7
          // }
        ],
        subject: 0,
        table: [],
        car_type: 0,

        carClassify: [],

        list: [],
        showModal: false,
      }
    },
    computed: {
      ...mapState(['carTypeParams'])
    },
    watch: {
      showModal(val) {
        if (val) {
          document.body.style.overflow = 'hidden';
        } else {
          document.body.style.overflow = '';
        }
      }
    },
    beforeDestroy() {
      document.body.style.overflow = '';
    },
    mounted() {
      // this.threeTest()
    },
    methods: {
      closeModal() {
        this.showModal = false;
      },
      go(item, txt) {
        this.$Go('case', {
          id: item.id,
          txt: txt,
          car: this.carTypeParams.name,
          carId: this.car_type + 1,
          subject: item.name,
          subjectId: this.navClassify[this.subject].id
        })
      },
      goCollect() {
        this.$Go('case', {
          txt: '收藏库'
        })
      },
      gomis() {
        this.$Go('case', {
          txt: '错题库'
        })
      },
      goExam(txt) {
        this.$Go('case', {
          txt: txt,
          car: this.carTypeParams.name,
          carId: this.car_type + 1,
          subject: this.navClassify[this.subject].name,
          subjectId: this.navClassify[this.subject].id
        })
        this.closeModal()
      },
      selectSubject(e) {
        this.subject = e
        this.getClassify()
      },
      selectCar(e) {
        this.car_type = e
        this.car_type1 = e
        this.$store.commit('ADD_CARTYPEPARAMS', {
          car_type: e,
          carObject: this.carClassify1[e]
        })
        this.getClassify()
      },
      threeTest() {
        this.getClassify1()
      },
      getClassify() {
        console.log('this.subject', this.subject)
        let subject = this.subject == 0 ? 1 : this.subject == 1 ? 4 : this.subject == 2 ? 6 : this.subject == 3 ?
          5 : this.subject == 4 ? 7 : ''
        console.log('subject', subject)

        // 三力测试 专属搜索项  备注：三力测试其实相当于一个其他的小车类型
        let type = ''
        if (this.car_type == 4) {
          type = '三力测试'
        }
        this.axios
          .post('/index/cate', {
            vip: 1,
            subject: subject,
            car_type: this.car_type + 1,
            type: type,
          })
          .then(res => {
            this.list = res
          })
          .catch(error => {})
      },
      getClassify1() {
        this.axios
          .post('/index/cate', {
            vip: 1,
            subject: 7,
            car_type: this.car_type + 1
          })
          .then(res => {
            this.list = res
          })
          .catch(error => {})
      }
      // let aA =this.one(a)
      // one(arr) {
      // 	let newArr = [];
      // 	function two(arr){
      // 		arr.forEach(item => {
      // 			if(item.childList.length){
      // 				two(item.childList)
      // 				newArr.push(item)
      // 			}else{
      // 				newArr.push(item)
      // 			}
      // 		})
      // 	}
      // 	two(arr)
      // 	return newArr;
      // },
    },
    created() {
      this.car_type = this.carTypeParams.car_type
      this.carClassify = this.carTypeParams.carObject
      this.getClassify()
    },
    // 跳转之后不自动更新
    // activated() {
    //   this.car_type = this.carTypeParams.car_type
    //   this.carClassify = this.carTypeParams.carObject
    //   this.getClassify()
    // }
  }
</script>

<style>
</style>
<style scoped lang="scss">
  .headerlog {
    /deep/ .el-dialog__header {
      padding: 0 !important;
    }

    /deep/ .el-dialog__body {
      padding: 0 !important;
    }
  }

  // .left {
  // }

  .navClassify {
    // background: linear-gradient(180deg, #3cb4fe 0%, #328dfb 100%);
    background: #d1edff;
    border-radius: 20px;

    .navClassifyBlock {
      width: 350px;
      height: 88px;
      text-align: center;
      font-size: 23px;
      color: #328efb;
    }

    .change {
      // background: #006aa2;
      background: #3bb2fe;
      font-weight: bold;
      transition: all 0.3s;
      border-radius: 20px;
      color: #fff;
      // width: 250px;
    }
  }

  .left {
    .change {
      // background: #ebf1ff;
      background: #31a6ee;
      transition: all 0.3s;
      // color: #3cb4fe;
    }
  }

  .carType {
    .block {
      width: 100%;
    }
  }

  .arrList {
    width: 465px;
    height: 40px;
    text-align: center;
    margin-top: 20px;
    line-height: 40px;
    font-size: 25px;
  }

  // 考试确认框模态框
  .modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }

  .modal-content {
    background-color: white;
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.3s;
  }

  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
  .rule-item {
    margin-bottom: 10px;
  }
  .tip-text {
    color: red;
    margin-bottom: 10px;
  }
  .operation-tip {
    color: #666;
        font-size: 18px;
        margin-top: 20px;
  }
  // 考试确认框模态框 - 结束
</style>



// WEBPACK FOOTER //
// src/pages/index/index.vue